import '@/scripts/legacy-ui-library/toolkit';

// Legacy helper
import pageLoader from '@/scripts/libs/page-loader';
import initializer from '@/scripts/libs/initializer';
// Legacy page module
import Banner from '@/scripts/pages/shared/legacy-pages/banner';
import VSNavbar from '@/scripts/pages/shared/legacy-pages/vs-navbar';
import VSCollectionQuestion from '@/scripts/pages/shared/legacy-pages/vs-collection-question';
import VSCommunity from '@/scripts/pages/shared/legacy-pages/vs-community';
import VSCommunityQuestionNew from '@/scripts/pages/shared/legacy-pages/vs-community-question-new';
import VSFeedback from '@/scripts/pages/shared/legacy-pages/vs-feedback';
import VSFooter from '@/scripts/pages/shared/legacy-pages/vs-footer';

// New page module
import routes from '@/scripts/routes';

// Module registration
const components = {
  shared: [
    Banner,
    VSNavbar,
    VSCollectionQuestion,
    VSCommunity,
    VSCommunityQuestionNew,
    VSFeedback,
    VSFooter,
  ],
};

initializer.initializeApplication();

$(() => {
  // Older page rely on jQuery to be ready first.
  // Many component also require the specification of template string to be changed first.
  components.shared.forEach((component) => { component.init(); });
});

pageLoader.load(routes);

// Services (Self initialized)
import('@/scripts/services/eventManager');
